module.exports = __webpack_public_path__ + "static/assets/53ef96392ac2a92361884783808a02c9.svg";